function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#DCAA46;}\n\t.st1{fill:#6B676E;}\n\t.st2{fill:#585661;}\n\t.st3{fill:#FFD750;}\n\t.st4{fill:#FFDEB7;}\n\t.st5{fill:#D2B49B;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M325.9,311.6c21.5,0,39.9,9.8,51.7,21.6c13.7,13.7,26.8,14.1,27.3,14.1c4.5,0.1,8.2,3.8,8.1,8.4 c0,4.5-3.7,8.2-8.2,8.2c-0.8,0-20.2-0.2-38.9-19c-5.3-5.3-33.6-30.4-72.6-7c-3.9,2.4-9,1.1-11.3-2.8c-2.3-3.9-1.1-9,2.8-11.3 C299.1,315.1,313.1,311.6,325.9,311.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M297.3,372.1c0.4,0,0.7,0,1.1,0.1c3.6,0.5,35.4,5,46.8,19.7c6.2,7.9,9.4,16.6,12,23.6c1.2,3.2,2.9,7.6,3.8,8.7 c5,5,21,11.6,29.8,14.5c4.3,1.4,6.7,6.1,5.2,10.5c-1.4,4.3-6.1,6.7-10.5,5.2c-2.7-0.9-26.9-9.2-36.3-18.5 c-3.5-3.5-5.4-8.6-7.6-14.6c-2.3-6.2-5-13.3-9.6-19.3c-5.2-6.7-24.1-11.9-35.9-13.4c-4.5-0.6-7.7-4.7-7.1-9.3 C289.7,375.1,293.2,372.1,297.3,372.1z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M272.5,446.5c3.9,0,7.4,2.8,8.1,6.8c0.1,0.6,5.5,26.9,28.5,37.5c21.8,10.1,52.6,3.9,91.6-18.4 c4-2.3,9-0.9,11.3,3.1c2.3,4,0.9,9-3.1,11.3c-44,25.1-80,31.5-106.9,19c-30.9-14.4-37.3-48-37.6-49.5c-0.8-4.5,2.2-8.8,6.7-9.6 C271.6,446.6,272.1,446.5,272.5,446.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M322.1,0.1c0.9,0,1.8,0.1,2.7,0.4c4.3,1.5,6.6,6.2,5.1,10.5c-4.6,13.5,23.1,98.9,66,203 c4.6,11.3-13.1,64-21.4,76.4c-1.2,1.8-4.9,7.3-11.1,7.3c-10.4,0-24.2-7.9-41.8-17.8c-18.5-10.5-39.4-22.3-53.3-22.3 c-4.6,0-8.3-3.7-8.3-8.3s3.7-8.3,8.3-8.3c18.3,0,41.2,13,61.4,24.5c11.5,6.5,24.3,13.8,31.2,15.3c6.9-10,19.7-52.2,19.3-61.2 c-28.5-69.3-74.7-188.6-66-214C315.5,2.2,318.7,0.1,322.1,0.1z M380.3,219.2L380.3,219.2L380.3,219.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M186.1,311.6c-21.5,0-39.9,9.8-51.7,21.6c-13.7,13.7-26.8,14.1-27.3,14.1c-4.5,0.1-8.2,3.8-8.1,8.4 c0,4.5,3.7,8.2,8.2,8.2c0.8,0,20.2-0.2,38.9-19c5.3-5.3,33.6-30.4,72.6-7c3.9,2.4,9,1.1,11.3-2.8c2.3-3.9,1.1-9-2.8-11.3 C212.9,315.1,198.9,311.6,186.1,311.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M214.7,372.1c-0.4,0-0.7,0-1.1,0.1c-3.6,0.5-35.4,5-46.8,19.7c-6.2,7.9-9.4,16.6-12,23.6 c-1.2,3.2-2.9,7.6-3.8,8.7c-5,5-21,11.6-29.8,14.5c-4.3,1.4-6.7,6.1-5.2,10.5c1.4,4.3,6.1,6.7,10.5,5.2c2.7-0.9,26.9-9.2,36.3-18.5 c3.5-3.5,5.4-8.6,7.6-14.6c2.3-6.2,5-13.3,9.6-19.3c5.2-6.7,24.1-11.9,35.9-13.4c4.5-0.6,7.7-4.7,7.1-9.3 C222.3,375.1,218.8,372.1,214.7,372.1z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M239.5,446.5c-3.9,0-7.4,2.8-8.1,6.8c-0.1,0.6-5.5,26.9-28.5,37.5c-21.8,10.1-52.6,3.9-91.6-18.4 c-4-2.3-9-0.9-11.3,3.1c-2.3,4-0.9,9,3.1,11.3c44,25.1,80,31.5,106.9,19c30.9-14.4,37.3-48,37.6-49.5c0.8-4.5-2.2-8.8-6.7-9.6 C240.4,446.6,240,446.5,239.5,446.5z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M197.7,5.7c8.7,25.4-37.5,144.6-66,214c-0.4,9,12.4,51.2,19.3,61.2c7-1.6,19.8-8.8,31.2-15.3 c20.2-11.5,43.2-24.5,61.4-24.5c4.6,0,8.3,3.7,8.3,8.3s-3.7,8.3-8.3,8.3c-13.9,0-34.8,11.9-53.3,22.3c-17.5,9.9-31.4,17.8-41.8,17.8 c-6.1,0-9.8-5.5-11.1-7.3c-8.3-12.4-26-65.1-21.4-76.4c42.9-104.1,70.6-189.5,66-203c-1.5-4.3,0.8-9,5.1-10.5 c0.9-0.3,1.8-0.4,2.7-0.4C193.3,0.1,196.5,2.2,197.7,5.7z M131.7,219.2L131.7,219.2L131.7,219.2z"
});

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M227.1,421.7h57.9c11.4,0,20.7,9.3,20.7,20.7l0,0c0,11.4-9.3,20.7-20.7,20.7h-57.9c-11.4,0-20.7-9.3-20.7-20.7 l0,0C206.4,431,215.6,421.7,227.1,421.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M198.1,355.6c0,41.1,25.9,74.4,57.9,74.4s57.9-33.3,57.9-74.4c0-35.6-19.5-65.3-45.5-72.7v-34.8h-24.8v34.8 C217.6,290.2,198.1,320,198.1,355.6z"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M256,430c32,0,57.9-33.3,57.9-74.4c0-8.1-1-15.8-2.9-23.1c-16.1-6.3-34.9-10-55-10c-20.1,0-38.9,3.7-55,10 c-1.8,7.3-2.9,15-2.9,23.1C198.1,396.7,224,430,256,430z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M298.5,426.9c-3.7,9.2-8.7,17.1-14.5,23.1c-5.1,5.2-0.6,14.2,6.4,12.3c0.3-0.1,0.5-0.1,0.8-0.2 c6.4-1.9,11.6-7.2,13.5-13.6C307.2,439.9,304.2,431.9,298.5,426.9z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M189.9,198.5c0-90.9,29.6-165.4,66.1-165.4s66.1,73.4,66.1,165.4c0,45.7-29.6,57.9-66.1,57.9 S189.9,244.2,189.9,198.5z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M331.3,354.7c6.2-16.5,100-318.2,66.1-347.2c-19.3-16.5-30-2.1-33.1,8.3s-57.9,339-57.9,339 S325.1,371.3,331.3,354.7z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M213.5,426.9c-5.7,5-8.7,13-6.2,21.6c1.9,6.4,7.1,11.6,13.5,13.6c0.3,0.1,0.5,0.2,0.8,0.2 c7.1,1.9,11.6-7.1,6.5-12.3C222.2,444,217.2,436.1,213.5,426.9z"
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.8383 -0.5453 0.5453 0.8383 -144.7951 229.6485)",
  className: "st5",
  cx: 314.7,
  cy: 358.9,
  rx: 16.5,
  ry: 12.4
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M180.7,354.8c-6.2-16.5-100-318.2-66.1-347.2c19.3-16.5,30-2.1,33.1,8.3s57.9,339,57.9,339 S186.9,371.4,180.7,354.8z"
});

var _ref16 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.5453 -0.8383 0.8383 0.5453 -211.2275 328.5432)",
  className: "st5",
  cx: 197.2,
  cy: 359,
  rx: 12.4,
  ry: 16.5
});

var _ref17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M322.1,200.1c0-0.5,0.1-1,0.1-1.6c0-11.2-0.5-22.2-1.3-32.7c-19.4-5.4-41.4-8.6-64.8-8.6 c-23.4,0-45.4,3.1-64.8,8.4c-0.9,10.6-1.3,21.7-1.3,32.9c0,0.6,0.1,1.1,0.1,1.6c28.2-6.8,51.5-18.4,66.1-32.8 C270.5,181.8,293.9,193.3,322.1,200.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M256,215c22.8,0,43.3,6.6,58.2,17c3.5-5.8,5.9-13,7.1-21.6c-18.1-7.5-40.7-12-65.3-12 c-24.6,0-47.2,4.5-65.3,12c1.2,8.5,3.5,15.6,7,21.4C212.6,221.5,233.2,215,256,215z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M295.4,65.8c-11-20.4-24.6-32.6-39.4-32.6c-14.7,0-28.3,12.2-39.2,32.6c17-1.5,31.4-6.7,39.2-13.8 C263.9,59.1,278.3,64.3,295.4,65.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M256,76.5c11.7,12.2,30.9,21.6,54.1,26.8c-3.1-10.9-6.7-20.8-10.7-29.5c-13.2-3.4-27.9-5.3-43.4-5.3 c-15.4,0-30,1.9-43.2,5.2c-4,8.8-7.7,18.7-10.8,29.7C225.2,98.1,244.3,88.6,256,76.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M256,117.8c13.9,14.7,36.2,26.4,63.3,33.1c-1.5-12.7-3.6-24.7-6.3-35.9c-17.3-4.7-36.6-7.4-57.1-7.4 c-20.4,0-39.7,2.7-57,7.4c-2.7,11.2-4.8,23.3-6.4,36C219.8,144.2,242.1,132.4,256,117.8z"
}));

function SvgWasp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasp);
export default __webpack_public_path__ + "static/media/wasp.4fcb36d0.svg";
export { ForwardRef as ReactComponent };